import React, { FC } from 'react'
import { Field } from 'formik'
import styled from 'styled-components'
import Icon from '@ucheba/ui/icons/icon__close.svg'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { TextField } from '@ucheba/ui/components/TextField/desktop'
import { Select } from '@ucheba/ui/components/Select/desktop'
import { IFieldsAddEgeItem } from '../types'

const Block = styled.div`
  position: relative;
`

const IconBlock = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 2px;
  cursor: pointer;
`

const GridColSC = styled(GridCol)`
  display: flex;
  align-items: center;
`

const SelectEgeDialogEgeItem: FC<IFieldsAddEgeItem> = (props) => {
  const { list, item, scoreName, examIdName, onDelete } = props

  if (item.examId && item.examId.includes(String(12))) {
    return (
      <Block>
        <Grid spacing='small' justifyContent='space-between'>
          <GridColSC width='208px'>
            <Text>Русский язык</Text>
          </GridColSC>

          <GridCol width='112px'>
            <Field
              name={scoreName}
              as={TextField}
              label='Баллы'
              pattern='[0-9]*'
              // костыль чтобы валидация и ограничение работали в safari
              type='text'
              min={1}
              max={100}
            />
          </GridCol>
        </Grid>
      </Block>
    )
  }

  return (
    <Block>
      <Grid spacing='small'>
        <GridCol width='208px'>
          <Field
            autocomplete
            noItems='Такой предмет не найден'
            items={list}
            name={examIdName}
            keyValue='id'
            label='Предмет'
            as={Select}
            suggested
          />
        </GridCol>

        <GridCol width='88px'>
          <Field
            name={scoreName}
            as={TextField}
            // костыль чтобы валидация и ограничение работали в safari
            type='text'
            label='Баллы'
            pattern='[0-9]*'
            min={1}
            max={100}
          />
        </GridCol>

        <IconBlock onClick={onDelete}>
          <Icon width='18px' height='18px' />
        </IconBlock>
      </Grid>
    </Block>
  )
}

export default SelectEgeDialogEgeItem
